import Vuex from 'vuex'
import Vue from 'vue'
import VuexPersistence from 'vuex-persist'

import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import initialState from './initialState'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})

const store = new Vuex.Store({
  state: initialState,
  actions,
  getters,
  mutations,
  plugins: [vuexLocal.plugin]
})

export default store
